document.addEventListener("DOMContentLoaded", () => {
  const bookingLinks = [...document.querySelectorAll("a")].filter(link =>
    link.innerText.toLowerCase().includes("book")
  );
  bookingLinks.forEach(link => {
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener noreferrer");
  });
});
